export const upTosmallScreenSelector = '@media (max-width: 479px)';
export const upToMediumScreenSelector = '@media (max-width: 639px)';
export const upToBigScreenSelector = '@media (max-width: 767px)';
export const upToLargeScreenSelector = '@media (max-width: 1023px)';
export const upToXLScreenSelector = '@media (max-width: 1365px)';
export const upToXXLScreenSelector = '@media (max-width: 1919px)';

export const downTosmallScreenSelector = '@media (min-width: 480px)';
export const downToMediumScreenSelector = '@media (min-width: 640px)';
export const downToBigScreenSelector = '@media (min-width: 768px)';
export const downToLargeScreenSelector = '@media (min-width: 1023px)';
export const downToXLScreenSelector = '@media (min-width: 1366px)';
export const downToXXLScreenSelector = '@media (min-width: 1920px)';

export const orientationLandscape = (media: string) => `${media} and (orientation: landscape)`;
